import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, firstValueFrom, map } from 'rxjs'
import { Ok, Result } from 'ts-results'
import { environment } from '../../environments/environment'
import { AuthService } from '../auth/services/auth.service'
import { handleBasicHttpError } from '../common/functional-libraries/utils.library'
import { SubscriptionDataDto } from './subscription-data.dto'
import { SubscriptionData } from './subscription-data.model'
import { SubscriptionDataDtoConverter } from './subscripton-data-dto.converter'

@Injectable({
  providedIn: 'root',
})
export class AccountClient {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  public getSubscriptionInfo(): Promise<Result<SubscriptionData, Error>> {
    const result = this.http
      .get<SubscriptionDataDto>(`${environment.apiUrl}/accounts/subscription`, {
        headers: this.authService.getAuthHeaders(),
      })
      .pipe(
        map((response) =>
          Ok(SubscriptionDataDtoConverter.toSubscriptionData(response)),
        ),
        catchError((error: HttpErrorResponse) =>
          handleBasicHttpError<SubscriptionData>(error),
        ),
      )

    return firstValueFrom(result)
  }
}
